import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { DiscoveryCategoryPageProps } from './components/DiscoveryCategoryPageContentWrapper';

const DiscoveryCategoryPageContentWrapper = lazy(
  () => import('./components/DiscoveryCategoryPageContentWrapper'),
);

export const DiscoveryCategoryPage = wrapLazyNavigatorScreen(
  (props: DiscoveryCategoryPageProps) => {
    return <DiscoveryCategoryPageContentWrapper {...props} />;
  },
  {
    headerShown: false,
    animationEnabled: false,
  },
);
